export const DEFAULT_TAB_PARAM = {
  0: {
    keywords: "", // 搜索关键字，空格："或"关系， +："且"关系
    timeType: 8, // 搜索时间类型 1=近一年，2近一周，3=近一月，4  5  6 自定义时间区间 7今天   8近三个月   9近半年, 103=全部
    filtermode: 8, // 当前分类的id检索模式，默认全文=8 全文附件=1
    searchMode: 1, //  搜索模式 0=模糊(免费) 1=精准(付费) （2=智能,暂时隐藏）
    currentPage: 1, // 当前页，默认1
    numPerPage: 20, //  每页多少条，默认20
    sortType: "2", // 排序方式：0自动排序【禅道587】 1时间倒序 2综合排序 3关联度排序 4按报名时间倒序 5按金额倒序 6相关性排序 7智能排序
    allType: -1, //后端没用这个不知为啥穿
    noticeSegmentTypeStr: "",
    beginAmount: "", // 筛选金额（下限）
    endAmount: "", //   筛选金额（上限）
    purchasingUnitIdList: "", //采购单位
    threeClassifyTagStr: "", //行业分类三級分类页面一级
    fourLevelCategoryIdListStr: "", //行业分类四级分类页面二级
    threeLevelCategoryIdListStr: "", //家具的三级类页面二级
    //   "levelId": "",//家具level  后端确认没有这个字段
    searchDataType: 0, //查询数据类型：默认不传全部数据 0综合 1招标数据  2拟在建数据  3审批数据  31查询301数据  32查询601数据  4vip数据  41业主委托数据   42拟在建转vip数据
    types: "-1", // 信息类型 【默认综合=-1 】【公告=0 预告=1 变更=2 结果=3 国土=4】【拟在建项目=101】【VIP项目=201】【审批项目=301】
    showContent: 1, //
    hasTenderTransferProject: 1,
    newAreas: "", //d// 地区搜索 传递对应的areaid，如果多个值，用逗号隔开，默认为全国搜索，所以，如果全国搜索请不要传递任何信息新的搜索地区的方式，只需要传入所有要查询的地区即可，不用传入子地区，用","隔开
    hasChooseSortType: 1, //是否手动选择排序方式
    summaryType: 0,
    //vip筛选
    // biddingType: "", //招标方式
    // fundsSourceList: "", //资金来源
    // hasAgent: "", //代理机构
    // registrationStatus: "", // 报名状态：0未开始  1报名中  2已结束
    // beginAmount: "", // 筛选金额（下限）
    // endAmount: "", //   筛选金额（上限）
    // hasPhone: "", //    是否含联系电话：0无 1有
    // hasAnnex: "", //    是否包含附件：0无 1有
    // hasLinkName: "", // 是否含招标联系人：0无 1有
    // tenderOrBidderName: "", // 在已选条件下搜索其他内容
    // tenderOrBidderType: "3", // 搜索类型 与tenderOrBidderName关联 1、搜招中标单位名称 2、搜招中标联系人 3、搜全文
    progIdAndNoticeSegmentTypeMaps: {}, //新加字段，废弃noticeSegmentTypeStrprogIdList
  },
  1: {
    keywords: "",
    timeType: 8,
    filtermode: 8,
    searchMode: 1,
    currentPage: 1,
    numPerPage: 20,
    sortType: "2",
    allType: -1,
    noticeSegmentTypeStr: "",
    beginAmount: "",
    endAmount: "",
    purchasingUnitIdList: "",
    threeClassifyTagStr: "",
    fourLevelCategoryIdListStr: "",
    threeLevelCategoryIdListStr: "",
    levelId: "",
    types: "-1",
    showContent: 1,
    hasLinkName: "",
    searchDataType: 1,
    progIdList: [1, 0, 99, 2, 4, 5],
    newAreas: "",
    hasChooseSortType: 1,
    summaryType: 0,
    progIdAndNoticeSegmentTypeMaps: {
      1: [],
      0: [],
      99: [],
      2: [],
      4: [],
      5: [],
    }, //新加字段，废弃noticeSegmentTypeStrprogIdList
  },
  2: {
    keywords: "",
    timeType: 8,
    filtermode: 8,
    searchMode: 1,
    currentPage: 1,
    numPerPage: 20,
    sortType: "2",
    allType: -1,
    noticeSegmentTypeStr: "",
    beginAmount: "",
    endAmount: "",
    purchasingUnitIdList: "",
    threeClassifyTagStr: "",
    fourLevelCategoryIdListStr: "",
    threeLevelCategoryIdListStr: "",
    levelId: "",
    types: "-1",
    searchDataType: 1,
    showContent: 1,
    hasLinkName: "",
    progIdAndNoticeSegmentTypeMaps: { 3: [], 4: [], 5: [] }, //新加字段，废弃noticeSegmentTypeStrprogIdList
    newAreas: "",
    hasChooseSortType: 1,
    summaryType: 0,
  },
  3: {
    keywords: "",
    timeType: 8,
    filtermode: 8,
    searchMode: 1,
    currentPage: 1,
    numPerPage: 20,
    sortType: "2",
    allType: -1,
    noticeSegmentTypeStr: "",
    beginAmount: "",
    endAmount: "",
    purchasingUnitIdList: "",
    threeClassifyTagStr: "",
    fourLevelCategoryIdListStr: "",
    threeLevelCategoryIdListStr: "",
    levelId: "",
    searchDataType: 2,
    types: "101",
    jzjd: "",
    starNums: "5,4,3,3.5",
    hasLinkName: "",
    hasTenderTransferProject: 1,
    newAreas: "",
    hasChooseSortType: 1,
    progIdAndNoticeSegmentTypeMaps: {},
  },
  4: {
    keywords: "",
    timeType: 8,
    filtermode: 8,
    searchMode: 1,
    currentPage: 1,
    numPerPage: 20,
    sortType: "2",
    allType: -1,
    noticeSegmentTypeStr: "",
    beginAmount: "",
    endAmount: "",
    purchasingUnitIdList: "",
    threeClassifyTagStr: "",
    fourLevelCategoryIdListStr: "",
    threeLevelCategoryIdListStr: "",
    levelId: "",
    searchDataType: 3,
    types: "301",
    hasLinkName: "",
    progIdList: [31, 32, 33, 34, 35, 36, 61, 37],
    progIdAndNoticeSegmentTypeMaps: {
      31: [],
      32: [],
      33: [],
      34: [],
      35: [],
      36: [],
      61: [],
      37: [],
    },
    newAreas: "",
    hasChooseSortType: 1,
  },
};
export const DEFAULT_TAB_CHOSE_PARAM = {
  0: {
    allType: { id: "-1" },
    filtermode: { id: 8 },
    searchMode: { id: 0 },
    newAreas: { id: "-1" },
    purchasingUnitIdList: { id: "-1" },
    updateSearchChoseParams: {},
    timeType: { id: 8 },
    Industry: { id: "-1" },
    SuperSearchValue: {
      biddingType: { id: "-1" },
      fundsSourceList: { id: "-1" },
      hasAgent: { id: "-1" },
      registrationStatus: { id: "-1" },
      AmountItem: { id: "-1" },
      hasPhone: { id: "-1" },
      hasLinkName: { id: "-1" },
    },
    tenderOrBidderName: {},
    relatedWord: {},
    excludeWord: {},
  },
  1: {
    filtermode: { id: 8 },
    searchMode: { id: 0 },
    newAreas: { id: "-1" },
    purchasingUnitIdList: { id: "-1" },
    updateSearchChoseParams: {},
    timeType: { id: 8 },
    typeTender: { id: "-1" },
    Industry: { id: "-1" },
    typeWinBidding: { id: "-1" },
    SuperSearchValue: {
      biddingType: { id: "-1" },
      fundsSourceList: { id: "-1" },
      hasAgent: { id: "-1" },
      registrationStatus: { id: "-1" },
      hasPhone: { id: "-1" },
      hasLinkName: { id: "-1" },
    },
    tenderOrBidderName: {},
    relatedWord: {},
    excludeWord: {},
    AmountItem: {},
  },
  2: {
    filtermode: { id: 8 },
    searchMode: { id: 0 },
    purchasingUnitIdList: { id: "-1" },
    updateSearchChoseParams: {},
    timeType: { id: 8 },
    Industry: { id: "-1" },
    typeWinBidding: { id: "-1" },
    SuperSearchValue: {
      fundsSourceList: { id: "-1" },
      hasPhone: { id: "-1" },
      hasLinkName: { id: "-1" },
    },
    tenderOrBidderName: {},
    relatedWord: {},
    excludeWord: {},
    AmountItem: {},
  },
  3: {
    filtermode: { id: 8 },
    searchMode: { id: 0 },
    newAreas: { id: "-1" },
    purchasingUnitIdList: { id: "-1" },
    updateSearchChoseParams: {},
    timeType: { id: 8 },
    jzjd: { id: "-1" },
    relatedWord: {},
    excludeWord: {},
    starNums: { id: "5,4,3,3.5" },
  },
  4: {
    newAreas: { id: "-1" },
    filtermode: { id: 8 },
    searchMode: { id: 0 },
    purchasingUnitIdList: { id: "-1" },
    updateSearchChoseParams: {},
    timeType: { id: 8 },
    approverCType: { id: "-1" },
    relatedWord: {},
    excludeWord: {},
  },
};

//大搜索超级筛选对应key
export const SUPER_SEARCH_KEY = [
  "biddingType",
  "fundsSourceList",
  "hasAgent",
  "registrationStatus",
  "AmountItem",
  "hasPhone",
  "hasLinkName",
];
